module.exports = __webpack_public_path__ + "static/media/kybcomplete.b772439a.svg";